export const actions = {
    SET_LOADING: 'SET_LOADING',
    SET_LAST_ERROR_MESSAGE: 'SET_LAST_ERROR_MESSAGE',
    SET_FULLSCREEN_LOG_MESSAGE: 'SET_FULLSCREEN_LOG_MESSAGE',
    SET_AUTH_DEALER: 'SET_AUTH_DEALER',
    SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
    SET_AUTH_LOADED: 'SET_AUTH_LOADED',
    SET_AUTH_REMEMBER: 'SET_AUTH_REMEMBER',
    SHOW_SIDENAV: 'SHOW_SIDENAV',
    HIDE_SIDENAV: 'HIDE_SIDENAV',
    SET_SIDENAV: 'SET_SIDENAV',
    TOGGLE_SIDENAV: 'TOGGLE_SIDENAV',
    SET_FORM_ERRORS: 'SET_FORM_ERRORS',
    SET_MEDIA_BROWSER_DATA: 'SET_MEDIA_BROWSER_DATA',
    SET_APP_CONFIG: 'SET_APP_CONFIG',
};

export const setLoading = (value) => {
    return {
        type: actions.SET_LOADING,
        value: value,
    };
};

export const setLastErrorMessage = (value) => {
    return {
        type: actions.SET_LAST_ERROR_MESSAGE,
        value: value,
    };
};

export const setFullscreenLogMessage = (value) => {
    return {
        type: actions.SET_FULLSCREEN_LOG_MESSAGE,
        value: value,
    };
};

export const setAuthDealer = (value, remember) => {
    return {
        type: actions.SET_AUTH_DEALER,
        value: value,
        remember: remember,
    };
};

export const setAuthToken = (value, remember) => {
    return {
        type: actions.SET_AUTH_TOKEN,
        value: value,
        remember: remember,
    };
};

export const setAuthLoaded = (value) => {
    return {
        type: actions.SET_AUTH_LOADED,
        value: value,
    };
};

export const setAuthRemember = (value) => {
    return {
        type: actions.SET_AUTH_REMEMBER,
        value: value,
    };
};

export const setSideNav = (value) => {
    return {
        type: actions.SET_SIDENAV,
        value: value,
    };
};

export const toggleSideNav = () => {
    return {
        type: actions.TOGGLE_SIDENAV,
    };
};

export const setFormErrors = (value) => {
    return {
        type: actions.SET_FORM_ERRORS,
        value: value,
    };
};

export const setMediaBrowser = (data) => {
    return {
        type: actions.SET_MEDIA_BROWSER_DATA,
        value: data,
    };
};

export const setAppConfig = (data) => {
    return {
        type: actions.SET_APP_CONFIG,
        value: data,
    };
};
